export default __webpack_public_path__ + "static/media/tick.c0ef78b4.svg";